import React from 'react';
import { AlignLeft } from 'lucide-react';
import { CourseModule } from '../../../api/studentCoursesApi';
import ModuleCompleteButton from '../common/ModuleCompleteButton';

interface LabelModuleContentProps {
  contextId: string;
  moduleId: string;
  module: CourseModule | null;
}

const LabelModuleContent: React.FC<LabelModuleContentProps> = ({ contextId, moduleId, module }) => {
  return (
    <div className="bg-white rounded-xl border border-gray-200 shadow-sm overflow-hidden">
      {/* Header */}
      <div className="relative px-8 py-6" style={{ background: '#0F1F3D' }}>
        <div
          className="absolute top-0 left-0 right-0 h-0.5"
          style={{ background: 'linear-gradient(to right, #4F6BFF, #818CF8, #4F6BFF)' }}
        />
        <div className="flex items-center gap-4">
          <div
            className="rounded-xl p-3 shrink-0"
            style={{ background: 'rgba(79, 107, 255, 0.2)', border: '1px solid rgba(79, 107, 255, 0.4)' }}
          >
            <AlignLeft className="h-6 w-6" style={{ color: '#818CF8' }} />
          </div>
          <div>
            <p className="text-[10px] font-bold uppercase tracking-widest mb-1" style={{ color: '#818CF8' }}>
              Text &amp; Media
            </p>
            <h2 className="text-xl font-bold text-white leading-tight">
              {module?.name ?? 'Label'}
            </h2>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="px-8 py-8">
        {module?.description ? (
          <div
            className="prose prose-sm sm:prose max-w-none
              prose-headings:font-semibold prose-headings:text-gray-900
              prose-h1:text-2xl prose-h2:text-xl prose-h3:text-lg
              prose-p:text-gray-700 prose-p:leading-relaxed prose-p:my-3
              prose-a:text-blue-600 prose-a:underline hover:prose-a:text-blue-800
              prose-ul:my-3 prose-ul:pl-5 prose-ul:list-disc
              prose-ol:my-3 prose-ol:pl-5 prose-ol:list-decimal
              prose-li:text-gray-700 prose-li:my-1
              prose-strong:text-gray-900 prose-strong:font-semibold
              prose-blockquote:border-l-4 prose-blockquote:border-blue-300
              prose-blockquote:pl-4 prose-blockquote:italic prose-blockquote:text-gray-600
              prose-img:rounded-lg prose-img:shadow-md prose-img:my-4
              prose-hr:border-gray-200 prose-hr:my-6
              prose-table:border-collapse prose-td:border prose-td:border-gray-200
              prose-td:px-3 prose-td:py-2 prose-th:border prose-th:border-gray-300
              prose-th:px-3 prose-th:py-2 prose-th:bg-gray-50 prose-th:font-semibold"
            dangerouslySetInnerHTML={{ __html: module.description }}
          />
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <div className="rounded-full bg-gray-100 p-4 mb-4">
              <AlignLeft className="h-8 w-8 text-gray-300" />
            </div>
            <p className="text-gray-400 italic text-sm">No content available for this label.</p>
          </div>
        )}
      </div>

      {/* Footer */}
      <div className="sticky bottom-0 z-10 px-6 py-4 bg-gray-50 border-t border-gray-100 flex items-center justify-end">
        <ModuleCompleteButton contextId={contextId} moduleId={moduleId} variant="footer" />
      </div>
    </div>
  );
};

export default LabelModuleContent;
